'use client';

import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import styled from "styled-components";

import media from "styles/media";
import colors from "styles/colors";
import text from "styles/text";
import Star from "images/Vasion-Star.webp";
import {ReactComponent as X} from "images/Le-X.svg"; 

const PopUp = () => {
  const popupRef = useRef(null);
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && sessionStorage?.length === 0) {
      setShouldShow(true);
    }
  }, []);

  const closePopup = () => {
    if (popupRef.current) {
      gsap.to(popupRef.current, {
        opacity: 0,
        duration: 0.3,
        onComplete: () => setShouldShow(false),
      });
    }
  };

  if (!shouldShow) return null;

  return (
    <PopUpBackground ref={popupRef} className="popUp">
      <PopUpContainer>
        <CloseButton onClick={closePopup}>
         <X/>
        </CloseButton>
        <Header>
          We're moving... domains! <VasionStar src={Star} alt="Vasion Star" />
        </Header>
        <Body>
          PrinterLogic.com is officially moving to Vasion.com—our new digital
          home!
          <LineBreak />
          Don’t worry, the print experience you know and love won’t change.
          We’re just merging domains to provide a simplified, unified
          experience.
          <LineBreak />
          This change reflects our growth and broader mission to deliver modern,
          secure print and digital workflow solutions under one brand.
        </Body>
        <Button href='https://vasion.com'>Check Out Vasion.com</Button>
      </PopUpContainer>
    </PopUpBackground>
  );
};

const LineBreak = styled.div`
height: 1.25vw;

${media.fullWidth} {
  height: 20px;
}

${media.tablet} {
  height: 1.953vw;
}

${media.mobile} {
  height: 4.167vw;
}
`
const Button = styled.a`
  ${text.bodyMdBold};
  background: ${colors.primaryOrange};
  color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 2.875vw;
  border-radius: 1.75vw;

  &:hover {
    background: ${colors.white};
    color: ${colors.primaryOrange};
    border: 1px solid ${colors.primaryOrange};
  }

  ${media.fullWidth} {
    height: 46px;
  border-radius: 28px;
  }
  
  ${media.tablet} {
    height: 4.492vw;
    border-radius: 2.734vw;
  }
  
  ${media.mobile} {
    height: 9.583vw;
  border-radius: 5.833vw;
  }
`
const Body = styled.div`
  ${text.bodySm};
  color: ${colors.txtSubtle};
  display: flex;
  flex-direction: column;
  margin-bottom: 2vw;

  ${media.fullWidth} {
    margin-bottom: 32px;
  }
  
  ${media.tablet} {
    margin-bottom: 3.125vw;
  }
  
  ${media.mobile} {
    margin-bottom: 6.667vw;
  }
`
const VasionStar = styled.img`
  width: 2vw;
  height: 2vw;

  ${media.fullWidth} {
    width: 32px;
  height: 32px;
  }
  
  ${media.tablet} {
    width: 3.125vw;
    height: 3.125vw;
  }
  
  ${media.mobile} {
    width: 6.667vw;
    height: 6.667vw;
  }
`
const Header = styled.div`
  ${text.h4};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25vw;
  margin-bottom: 1.25vw;

  ${media.fullWidth} {
    gap: 4px;
  margin-bottom: 20px;
  }
  
  ${media.tablet} {
    gap: 0.391vw;
  margin-bottom: 1.953vw;
  }
  
  ${media.mobile} {
    gap: 0.833vw;
  margin-bottom: 4.167vw;
  }
`
const CloseButton = styled.div`
cursor: pointer;
  background: ${colors.primaryPurple};
  color: ${colors.white};
  display: flex;
  align-items: center;
  align-self: end;
  justify-content: center;
  width: 2.75vw;
  height: 2.75vw;
  border-radius: 6.25vw;
  padding: 0.5vw;
  margin-bottom: 1.25vw;
  margin-right: -1vw;

  path {
    stroke: ${colors.white};
  }

  &:hover {
    background: ${colors.white};
    path {
      stroke: ${colors.primaryPurple};
    }
    border: 1px solid ${colors.primaryPurple};
  }
  ${media.fullWidth} {
    width: 44px;
  height: 44px;
  border-radius: 100px;
  padding: 8px;
  margin-bottom: 20px;
  margin-right: -16px;
  }
  
  ${media.tablet} {
    width: 4.297vw;
  height: 4.297vw;
  border-radius: 9.766vw;
  padding: 0.781vw;
  margin-bottom: 1.953vw;
  margin-right: -1.563vw;
  }
  
  ${media.mobile} {
    width: 9.167vw;
  height: 9.167vw;
  border-radius: 20.833vw;
  padding: 1.667vw;
  margin-bottom: 4.167vw;
  margin-right: -3.333vw;
  }
`
const PopUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.white};
  height: auto;
  border-radius: 1.25vw;
  width: 26.813vw;
  padding: 1vw 2vw 2vw 2vw;

  ${media.fullWidth} {
    border-radius: 20px;
  width: 429px;
  padding: 16px 32px 32px 32px;
  }
  
  ${media.tablet} {
    border-radius: 1.953vw;
  width: 41.895vw;
  padding: 1.563vw 3.125vw 3.125vw 3.125vw;
  }
  
  ${media.mobile} {
    width: 89.167vw;
    padding: 3.333vw 6.667vw 6.667vw 6.667vw;
    border-radius: 4.167vw;
  }
`
const PopUpBackground = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background-color: rgba(27, 29, 33, 0.5);
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(30px);
`
export default PopUp
